export default () => ({
  el: undefined,
  init() {
    mrp.log(`RxModalDialogBasic init`);
    this.el = this.$el;
  },
  dismiss() {
    this.el.close();
  },
});
